"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _cmsFollowUp = _interopRequireDefault(require("@/api/cmsFollowUp"));

var _vuex = require("vuex");

var _auth = require("@/utils/auth");

var _avatar = _interopRequireDefault(require("@/assets/images/avatar.png"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {};
var _default = {
  name: 'Report0402',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  dicts: [],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '0402',
      url: 'api/Report0402',
      idField: 'rowId',
      sort: ['rowId,desc'],
      crudMethod: _objectSpread({}, _cmsFollowUp.default)
    });
  },
  data: function data() {
    return {
      isSearch: false,
      Avatar: _avatar.default,
      gridData: [],
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      direction: 'rtl',
      queryUsers: {},
      queryTypes: {},
      queryType: {},
      chatRecordInfo: '',
      chatRecordDialog: false,
      calenarTaksShow: false,
      currTableItem: '',
      currTableValue: '',
      dateValue: '',
      dateItems: [{
        value: '<>',
        tag: '=',
        label: '等于两数之间'
      }, {
        value: 'O',
        tag: 'O',
        label: '为空'
      }, {
        value: '∅',
        tag: '∅',
        label: '不为空'
      }],
      items: [{
        value: '=',
        tag: '=',
        label: '等于'
      }, {
        value: '!=',
        tag: '!=',
        label: '不等于'
      }, {
        value: '⊆',
        tag: '⊆',
        label: '包含'
      }, {
        value: '⊈',
        tag: '⊈',
        label: '不包含'
      } // , {
      //   value: 'n',
      //   tag: 'n',
      //   label: '等于任意一个'
      // }, {
      //   value: '!n',
      //   tag: '!n',
      //   label: '不等于任意一个'
      // }
      , {
        value: 'O',
        tag: 'O',
        label: '为空'
      }, {
        value: '∅',
        tag: '∅',
        label: '不为空'
      }],
      selectItems: [{
        value: '=',
        tag: '=',
        label: '等于'
      }, {
        value: '!=',
        tag: '!=',
        label: '不等于'
      } // , {
      //   value: '⊆',
      //   tag: '⊆',
      //   label: '包含'
      // }
      //   , {
      //     value: '⊈',
      //     tag: '⊈',
      //     label: '不包含'
      //   }
      , {
        value: 'n',
        tag: 'n',
        label: '等于任意一个'
      }, {
        value: '!n',
        tag: '!n',
        label: '不等于任意一个'
      }, {
        value: 'O',
        tag: 'O',
        label: '为空'
      }, {
        value: '∅',
        tag: '∅',
        label: '不为空'
      }],
      filters: [{
        text: "全部",
        value: "全部"
      }, {
        text: "INFO",
        value: "INFO"
      }, {
        text: "WARN",
        value: "WARN"
      }, {
        text: "ERROR",
        value: "ERROR"
      }],
      tableDataFilter2: [//表头筛选-筛选框内容2  （前端写死筛选条件）
      {
        value: 1,
        text: "ID"
      }, {
        value: 2,
        text: "自变量"
      }, {
        value: 3,
        text: "目标变量"
      }, {
        value: 4,
        text: "时间变量"
      }],
      checkAll: true,
      //默认全选
      checkedCities: [],
      //默认全选所有的数据
      listItems: [],
      rightItem: [],
      downloadRightItem: [],
      tempSelectionKeys: [],
      cols: [{
        prop: 'contractNumber',
        label: '合同号',
        width: 150
      }],
      cities: [{
        prop: 'workOrderNumber',
        label: '工单号',
        width: 150
      }, {
        prop: 'salesOrderNumber',
        label: '销售单号',
        width: 150
      }, {
        prop: 'contractNumber',
        label: '合同号',
        width: 150
      }, {
        prop: 'contact',
        label: '客户',
        width: 150
      }, {
        prop: 'contactNumber',
        label: '电话',
        width: 150
      }, {
        prop: 'contactAddress',
        label: '地址',
        width: 150
      }, {
        prop: 'workOrderClassification',
        label: '工单分类',
        width: 150
      }, {
        prop: 'workOrderType',
        label: '工单类型',
        width: 150
      }, {
        prop: 'productType',
        label: '产品类型',
        width: 150
      }, {
        prop: 'reasonType',
        label: '原因',
        width: 150
      }, {
        prop: 'workOrderLevel',
        label: '工单等级',
        width: 150
      }, {
        prop: 'workOrderSource',
        label: '工单来源',
        width: 150
      }, {
        prop: 'serviceTime',
        label: '上门时间',
        width: 150,
        query: 'serviceTime',
        type: 'date'
      }, {
        prop: 'serviceUser',
        label: '客服',
        width: 150
      }, {
        prop: 'batchNo',
        label: '批次编码',
        width: 150
      }, {
        prop: 'batchStatus',
        label: '批次状态',
        width: 150
      }, {
        prop: 'dispatchOrderNumber',
        label: '配送工单号',
        width: 150
      }, {
        prop: 'deliverDate',
        label: '配送时间',
        width: 150,
        query: 'deliverDate',
        type: 'date'
      }, {
        prop: 'deliverPerson',
        label: '配送人',
        width: 150
      }, {
        prop: 'supervisor',
        label: '安装主管',
        width: 150
      }, {
        prop: 'installDate',
        label: '安装时间',
        width: 150,
        query: 'installDate',
        type: 'date'
      }, {
        prop: 'installPerson',
        label: '安装人',
        width: 150
      }],
      permission: {
        add: ['null', 'null'],
        edit: ['null', 'null'],
        del: ['null', 'null']
      },
      optionsOrderList: [{
        value: '进行中',
        label: '进行中'
      }, {
        value: '需要再次上门',
        label: '需要再次上门'
      }, {
        value: '需要售后单',
        label: '需要售后单'
      }, {
        value: '已解决',
        label: '已解决'
      }],
      dialogTableVisible: false,
      dialogGDVisible: false,
      dialogAdd: false,
      dialogVisible: false,
      dialogAddProcess: false,
      dialogAddOrderList: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'user', 'filesUploadApi'])),
  methods: (_methods = {
    showSearchItem: function showSearchItem() {
      this.isSearch = !this.isSearch;
    },
    render: function render(h, _ref) {
      var _this = this;

      var column = _ref.column;
      var that = this;
      var key = this.onProp(column.label);
      var type = this.onColumnType(column.label);
      var userType = this.onUserType(column.label);

      if (type == 'select') {
        return h("el-popover", {
          "attrs": {
            "placement": "top-start",
            "title": column.label,
            "trigger": "click"
          }
        }, [h("el-select", {
          "on": {
            "focus": this.onShow,
            "change": this.onSelectChange
          },
          "attrs": {
            "name": column.label,
            "placeholder": "请选择"
          },
          "style": "width: 200px",
          "model": {
            value: _this.query[key],
            callback: function callback($$v) {
              _this.$set(_this.query, key, $$v);
            }
          }
        }, [this.filters.map(function (item) {
          return h("el-option", {
            "attrs": {
              "label": item.text,
              "value": item.value
            }
          });
        })]), h("div", {
          "style": "margin-top:10px"
        }, [h("el-button", {
          "style": "float:right;margin-left:10px",
          "attrs": {
            "icon": "el-icon-search",
            "size": "small"
          },
          "on": {
            "click": this.crud.toQuery
          }
        }, ["\u7B5B\u9009"])]), h("el-link", {
          "slot": "reference",
          "style": "font-size:13px;"
        }, [column.label]), h("div", {
          "slot": this.isSearch ? 'reference' : ''
        }, [h("div", {
          "style": "white-space: nowrap;overflow: hidden;"
        }, [h("el-select", {
          "on": {
            "change": this.onQueryTypeChange
          },
          "attrs": {
            "placeholder": "="
          },
          "style": "width: 58px;",
          "model": {
            value: _this.queryType[key],
            callback: function callback($$v) {
              _this.$set(_this.queryType, key, $$v);
            }
          }
        }, [this.selectItems.map(function (item) {
          return h("el-option", {
            "attrs": {
              "label": item.tag,
              "value": item.tag
            }
          }, [h("span", {
            "style": "float: left"
          }, [item.tag]), h("span", {
            "style": "float: right; color: #8492a6; font-size: 13px"
          }, [item.label])]);
        })]), h("el-select", {
          "on": {
            "focus": this.onShow,
            "change": this.onSelectChange,
            "blur": this.onSelectBlur
          },
          "attrs": {
            "name": column.label,
            "multiple": true,
            "placeholder": "请选择"
          },
          "style": "width: 120px",
          "model": {
            value: _this.query[key],
            callback: function callback($$v) {
              _this.$set(_this.query, key, $$v);
            }
          }
        }, [this.filters.map(function (item) {
          return h("el-option", {
            "attrs": {
              "label": item.text,
              "value": item.value
            }
          });
        })])])])]);
      } else if (type == 'date') {
        return h("el-popover", {
          "attrs": {
            "placement": "top-start",
            "title": column.label,
            "trigger": "click"
          }
        }, [h("el-date-picker", {
          "attrs": {
            "name": column.label,
            "type": "daterange",
            "range-separator": "-",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "default-time": ['00:00:00', '23:59:59'],
            "value-format": "yyyy-MM-dd HH:mm:ss"
          },
          "on": {
            "change": this.onDateChange,
            "focus": this.onDateFocus
          },
          "style": "width: 240px;",
          "model": {
            value: _this.query[key],
            callback: function callback($$v) {
              _this.$set(_this.query, key, $$v);
            }
          }
        }), h("div", {
          "style": "margin-top:10px"
        }, [h("el-button", {
          "style": "float:right;margin-left:10px",
          "attrs": {
            "icon": "el-icon-search",
            "size": "small"
          },
          "on": {
            "click": this.crud.toQuery
          }
        }, ["\u7B5B\u9009"])]), h("el-link", {
          "slot": "reference",
          "style": "padding-right:5px;font-size:13px;"
        }, [column.label]), h("div", {
          "slot": this.isSearch ? 'reference' : ''
        }, [h("div", {
          "style": "white-space: nowrap;overflow: hidden;"
        }, [h("el-select", {
          "on": {
            "change": this.onQueryTypeChange
          },
          "attrs": {
            "placeholder": "="
          },
          "style": "width: 58px;",
          "model": {
            value: _this.queryType[key],
            callback: function callback($$v) {
              _this.$set(_this.queryType, key, $$v);
            }
          }
        }, [this.dateItems.map(function (item) {
          return h("el-option", {
            "attrs": {
              "label": item.tag,
              "value": item.value
            }
          }, [h("span", {
            "style": "float: left"
          }, [item.tag]), h("span", {
            "style": "float: right; color: #8492a6; font-size: 13px"
          }, [item.label])]);
        })]), h("el-date-picker", {
          "attrs": {
            "name": column.label,
            "type": "daterange",
            "range-separator": "-",
            "start-placeholder": "开始",
            "end-placeholder": "结束",
            "format": "MM-dd",
            "default-time": ['00:00:00', '23:59:59'],
            "value-format": "yyyy-MM-dd HH:mm:ss"
          },
          "on": {
            "change": this.onDateChange,
            "focus": this.onDateFocus
          },
          "nativeOn": {
            "keyup": this.onKeyEnter
          },
          "style": "width: 145px;",
          "model": {
            value: _this.query[key],
            callback: function callback($$v) {
              _this.$set(_this.query, key, $$v);
            }
          }
        })])])]);
      } else if (type == 'no_search') {
        return h("el-link", {
          "style": "font-size:13px;"
        }, [column.label]);
      } else {
        if (userType != undefined) {
          return h("el-popover", {
            "attrs": {
              "placement": "top-start",
              "title": column.label,
              "trigger": "click"
            }
          }, [h("el-input", {
            "attrs": {
              "name": column.label,
              "clearable": true
            },
            "on": {
              "focus": this.onTextFocus,
              "change": this.onTextChange
            },
            "nativeOn": {
              "keyup": this.onKeyEnter
            },
            "style": "width: 200px;",
            "model": {
              value: _this.query[key],
              callback: function callback($$v) {
                _this.$set(_this.query, key, $$v);
              }
            }
          }), h("div", {
            "style": "margin-top:10px"
          }, [h("el-button", {
            "style": "float:right;margin-left:10px",
            "attrs": {
              "icon": "el-icon-search",
              "size": "small"
            },
            "on": {
              "click": this.crud.toQuery
            }
          }, ["\u7B5B\u9009"])]), h("el-link", {
            "slot": "reference",
            "on": {
              "click": this.onClickTab
            },
            "style": "font-size:13px;"
          }, [column.label]), h("div", {
            "slot": this.isSearch ? 'reference' : ''
          }, [h("div", {
            "style": "white-space: nowrap;overflow: hidden;"
          }, [h("el-select", {
            "on": {
              "change": this.onQueryTypeChange
            },
            "attrs": {
              "placeholder": "="
            },
            "style": "width: 58px;",
            "model": {
              value: _this.queryType[key],
              callback: function callback($$v) {
                _this.$set(_this.queryType, key, $$v);
              }
            }
          }, [this.items.map(function (item) {
            return h("el-option", {
              "attrs": {
                "label": item.tag,
                "value": item.tag
              }
            }, [h("span", {
              "style": "float: left"
            }, [item.tag]), h("span", {
              "style": "float: right; color: #8492a6; font-size: 13px"
            }, [item.label])]);
          })]), h("el-input", {
            "attrs": {
              "name": column.label,
              "clearable": true
            },
            "on": {
              "focus": this.onTextFocus,
              "change": this.onTextChange
            },
            "nativeOn": {
              "keyup": this.onKeyEnter
            },
            "style": "width: 145px;",
            "model": {
              value: _this.queryUsers[key],
              callback: function callback($$v) {
                _this.$set(_this.queryUsers, key, $$v);
              }
            }
          })])])]);
        } else {
          return h("el-popover", {
            "attrs": {
              "placement": "top-start",
              "title": column.label,
              "trigger": "click"
            }
          }, [h("el-input", {
            "attrs": {
              "name": column.label,
              "clearable": true,
              "placeholder": column.label
            },
            "on": {
              "focus": this.onTextFocus,
              "change": this.onTextChange
            },
            "nativeOn": {
              "keyup": this.onKeyEnter
            },
            "style": "width: 200px;",
            "model": {
              value: _this.query[key],
              callback: function callback($$v) {
                _this.$set(_this.query, key, $$v);
              }
            }
          }), h("div", {
            "style": "margin-top:10px"
          }, [h("el-button", {
            "style": "float:right;margin-left:10px",
            "attrs": {
              "icon": "el-icon-search",
              "size": "small"
            },
            "on": {
              "click": this.crud.toQuery
            }
          }, ["\u7B5B\u9009"])]), h("el-link", {
            "slot": "reference",
            "on": {
              "click": this.onClickTab
            },
            "style": "font-size:13px;"
          }, [column.label]), h("div", {
            "slot": this.isSearch ? 'reference' : ''
          }, [h("div", {
            "style": "white-space: nowrap;overflow: hidden;"
          }, [h("el-select", {
            "on": {
              "change": this.onQueryTypeChange
            },
            "attrs": {
              "placeholder": "="
            },
            "style": "width: 58px",
            "model": {
              value: _this.queryType[key],
              callback: function callback($$v) {
                _this.$set(_this.queryType, key, $$v);
              }
            }
          }, [this.items.map(function (item) {
            return h("el-option", {
              "attrs": {
                "label": item.tag,
                "value": item.tag
              }
            }, [h("span", {
              "style": "float: left"
            }, [item.tag]), h("span", {
              "style": "float: right; color: #8492a6; font-size: 13px"
            }, [item.label])]);
          })]), h("el-input", {
            "attrs": {
              "name": column.label,
              "clearable": true,
              "placeholder": column.label
            },
            "on": {
              "focus": this.onTextFocus,
              "change": this.onTextChange
            },
            "nativeOn": {
              "keyup": this.onKeyEnter
            },
            "style": "width: 145px;",
            "model": {
              value: _this.query[key],
              callback: function callback($$v) {
                _this.$set(_this.query, key, $$v);
              }
            }
          })])])]);
        }
      }
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    this.query.queryType = JSON.stringify(this.queryType);
    return true;
  }), (0, _defineProperty2.default)(_methods, "getProduceStatus", function getProduceStatus(produceStatus) {
    if (produceStatus === 0) {
      return '已分配';
    } else if (produceStatus === 2) {
      return '生产中';
    } else if (produceStatus === 4) {
      return '已生产';
    } else if (produceStatus === 6) {
      return '已入库';
    } else if (produceStatus === 8) {
      return '已出库';
    }
  }), (0, _defineProperty2.default)(_methods, "onKeyEnter", function onKeyEnter(_ref2) {
    var key = _ref2.key;

    if (key == 'Enter') {
      this.crud.toQuery();
    }
  }), (0, _defineProperty2.default)(_methods, "onSelectBlur", function onSelectBlur(e) {
    this.crud.toQuery();
  }), (0, _defineProperty2.default)(_methods, "onDateChange", function onDateChange(e) {
    var that = this;
    var name = this.currTableItem;
    that.query[name] = e;
    this.crud.toQuery();
  }), (0, _defineProperty2.default)(_methods, "onSelectChange", function onSelectChange(e) {
    var that = this;
    var name = this.currTableItem;
    that.query[name] = e;
  }), (0, _defineProperty2.default)(_methods, "onClickTab", function onClickTab(e) {
    var name = e.target.innerText;
    var key = this.onProp(name);
    console.log(key);
    this.currTableItem = key;
    this.currTableValue = this.query[key];
  }), (0, _defineProperty2.default)(_methods, "onReset", function onReset(e) {
    console.log(e);
    var key = this.currTableItem;
    this.currTableValue = '';
    this.query[key] = '';
  }), (0, _defineProperty2.default)(_methods, "onDateFocus", function onDateFocus(e) {
    var name = e._props.name;
    this.currTableItem = this.onProp(name);
  }), (0, _defineProperty2.default)(_methods, "resetQuery", function resetQuery() {
    this.queryType = {};
    this.queryUsers = {};
    this.crud.resetQuery();
  }), (0, _defineProperty2.default)(_methods, "onTextFocus", function onTextFocus(e) {
    console.log(e);
    var name = e.target.name;
    console.log(name);
    this.currTableItem = this.onProp(name); //判断是否筛选人员类型

    var cite = this.cities.filter(function (item) {
      return item.label === name;
    });
    var userType = cite[0].userType != undefined ? cite[0].userType : null;
    this.query['qType'] = userType;
  }), (0, _defineProperty2.default)(_methods, "onTextChange", function onTextChange(e) {
    if (e === '') {
      this.query['qType'] = '';
    }

    this.query[this.currTableItem] = e;
  }), (0, _defineProperty2.default)(_methods, "onUserTextChange", function onUserTextChange(e) {
    if (e === '') {
      this.query['qType'] = '';
    }

    this.queryUsers[this.currTableItem] = e;
  }), (0, _defineProperty2.default)(_methods, "onColumnType", function onColumnType(label) {
    var cite = this.cities.filter(function (item) {
      return item.label === label;
    });
    return cite[0].type;
  }), (0, _defineProperty2.default)(_methods, "onUserType", function onUserType(label) {
    var cite = this.cities.filter(function (item) {
      return item.label === label;
    });
    return cite[0].userType;
  }), (0, _defineProperty2.default)(_methods, "onProp", function onProp(label) {
    var cite = this.cities.filter(function (item) {
      return item.label === label;
    });
    var queryItem = cite[0].prop2 != undefined ? cite[0].prop2 : cite[0].prop;
    queryItem = cite[0].query != undefined ? cite[0].query : queryItem;
    queryItem = cite[0].userType != undefined ? cite[0].userType : queryItem;
    return queryItem;
  }), (0, _defineProperty2.default)(_methods, "onShow", function onShow(e) {
    console.log(e);
    var name = e.target.name;
    var cite = this.cities.filter(function (item) {
      return item.label === name;
    });
    this.filters = this.dict[cite[0].dict];
    this.currTableItem = this.onProp(e.target.name);
  }), (0, _defineProperty2.default)(_methods, "changeData", function changeData(data) {
    // console.log("传过来的数据")
    this.titleData.workOrderClassification = data;
  }), (0, _defineProperty2.default)(_methods, "changeSort", function changeSort(val) {
    console.log('changeSort');
    var order = 'desc';

    if (val.order == 'ascending') {
      order = 'asc';
    } //this.crud.sort = val.prop+','+order


    this.crud.sort = [val.prop + ',' + order];
    console.log(val);
    console.log(this.crud.sort);
    this.crud.toQuery();
  }), (0, _defineProperty2.default)(_methods, "isSortable", function isSortable(val) {
    if (this.isSearch) {
      return false;
    }

    return 'rowId';
  }), _methods)
};
exports.default = _default;